module.exports = __webpack_public_path__ + "img/b1.6c7142d1.png";